/**
* Cut Out Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Cut Out Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'cut-out-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const text = '.js-coh-animate-text';
      const circle = '.js-coh-animate-circle';
      const image = '.js-coh-animate-image';

      const basicFade = {
        autoAlpha: 1, // property/value
        duration: 0.35, // duration e.g. 0.35s
        ease: '0.25,0.1,0.25,1', // timing function e.g. ease
        stagger: 0.1, // delay e.g 0.1s
      };

      const basicSlideUp = {
        y: 0, // property/value
        duration: 1, // duration e.g. 1s
        ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
        stagger: 0.1, // delay e.g 0.1s
      };
      const basicSlideIn = {
        x: 102, // property/value
        duration: 1, // duration e.g. 1s
        ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
        stagger: 0.1, // delay e.g 0.1s
      };

      gsap.set( text, {autoAlpha: 0, y: 25} );
      gsap.set( image, {autoAlpha: 0, y: 25} );
      gsap.set( circle, {autoAlpha: 0, x: '100%'} );

      function cutOutHeroAnimations( textDelay, circleDelay, imageDelay ) {
        const tl = gsap.timeline();

        /* Text */
        tl.to( text, basicFade, textDelay );
        tl.to( text, basicSlideUp, textDelay );

        // /* Circle */
        tl.to( circle, basicFade, circleDelay );
        tl.to( circle, basicSlideIn, circleDelay );

        /* Image */
        tl.to( image, basicFade, imageDelay );
        tl.to( image, basicSlideUp, imageDelay );
      }

      if ( $( '.cut-out-hero' ).length ) {
        $( '.cut-out-hero' ).each( function( index, element ) {
          ScrollTrigger.create( {
            trigger: $( element ),
            once: true,
            start: 'top 90%',
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                cutOutHeroAnimations( 0, 0.3, '-=0.3' );
              }
            },
            onEnter: ( ) => {
              cutOutHeroAnimations( 0, 0.3, '-=0.3' );
            },
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'cut-out-hero', COMPONENT );
} )( app );
